// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu_3auv3","menuSpacer":"Menu_menuSpacer_1DGro"};